<template>
  <generic-modal
    size="large"
    :title="$t('visalink generator configuration')"
    icon="visa"
    image="/images/icons/visalink.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
  >
    <div class="description">
      <div class="ui two item top attached tabular menu" ref="tabss">
        <a class="active item" data-tab="entities">
          <i class="building icon"></i> {{ $t("entities") }}</a
        >
        <a class="item" data-tab="bulk">
          <i class="cubes icon"></i> {{ $t("bulk process") }}</a
        >
      </div>
      <div class="ui bottom attached active tab segment" data-tab="entities">
        <generic-container
          v-bind:show_plus="true"
          icon="cogs"
          :title="$t('entities')"
          v-on:add="add_setting"
        >
          <div class="ui grid" v-if="setup.settings.length">
            <div class="four wide column">
              <div class="ui vertical fluid pointing menu" ref="tabs">
                <a
                  class="item"
                  :data-tab="'t' + idx"
                  v-for="(setting, idx) in setup.settings"
                  :key="idx"
                >
                  <i
                    class="settings icon"
                    :class="{ blue: setting.is_default }"
                  ></i>
                  {{ setting.name }}
                </a>
              </div>
            </div>
            <div class="twelve wide stretched column">
              <div
                class="ui tab segment"
                :data-tab="'t' + idx"
                v-for="(setting, idx) in setup.settings"
                :key="idx"
              >
                <div class="ui form">
                  <div class="fields">
                    <div class="seven wide column field">
                      <label for>{{ $t("name") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="setup.settings[idx].name"
                      />
                    </div>
                    <div class="seven wide field">
                      <div class="ui toggle checkbox">
                        <input
                          type="checkbox"
                          name="set_as_default"
                          v-model="setup.settings[idx].is_default"
                        />
                        <label>{{ $t("set as default") }}</label>
                      </div>
                    </div>
                    <div class="two wide column field">
                      <label for>{{ $t("delete") }}</label>
                      <div
                        class="ui red icon button"
                        :data-tooltip="$t('delete')"
                        @click="remove_setting(idx)"
                      >
                        <i class="trash icon"></i>
                      </div>
                    </div>
                  </div>
                  <div class="fields">
                    <div class="ten wide field">
                      <label for="">{{ $t("image for visalink") }}</label>
                      <file-uploader
                        name="file"
                        url="/visalink/configuration/do-upload-logo"
                        @error="error_uploading"
                        @uploaded="end_uploading(idx, $event)"
                      />
                    </div>
                    <img
                      v-if="setting.file && setting.file.relative_path"
                      class="ui small image"
                      :src="api_host + '/' + setting.file.relative_path"
                    />
                  </div>
                  <div class="two fields">
                    <div class="field">
                      <label>{{ $t("visalink profile on bulk") }}</label>
                      <div
                        class="ui selection dropdown"
                        ref="profile_dropdown"
                        :data-idx="idx"
                      >
                        <input type="hidden" name="profile" />
                        <i class="dropdown icon"></i>
                        <div class="default text"></div>
                        <div class="menu"></div>
                      </div>
                    </div>
                    <div class="field">
                      <label>{{ $t("quota") }}</label>
                      <div
                        class="ui selection dropdown"
                        ref="quota_dropdown"
                        :data-idx="idx"
                      >
                        <input type="hidden" name="ddwn" />
                        <i class="dropdown icon"></i>
                        <div class="default text"></div>
                        <div class="menu"></div>
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <label>{{ $t("social networks") }}</label>
                    <div
                      class="ui multiple search selection dropdown"
                      ref="social_networks_dropdown"
                      :data-idx="idx"
                    >
                      <input type="hidden" name="ddwn" />
                      <i class="dropdown icon"></i>
                      <div class="default text"></div>
                      <div class="menu"></div>
                    </div>
                  </div>
                  <h5 class="ui dividing header">
                    {{ $t("short.io link policy") }}
                  </h5>
                  <div class="fields">
                    <div class="six wide field">
                      <div class="ui toggle checkbox" style="margin-top: 8px">
                        <input
                          type="checkbox"
                          name="set_as_default"
                          v-model="setup.settings[idx].shortio_shorten"
                        />
                        <label>{{ $t("shorten") }}</label>
                      </div>
                      <!-- <div class="ui toggle checkbox" style="margin-top:8px">
                        <input
                          type="checkbox"
                          name="set_as_default"
                          v-model="setup.settings[idx].reuse_link"
                        />
                        <label>{{ $t("reuse link") }}</label>
                      </div> -->
                    </div>
                    <div class="ten wide inline field">
                      <label for>{{
                        $t("reusable link time threshold")
                      }}</label>
                      <div class="two fields">
                        <div class="field">
                          <!-- <label for>{{
                            $t("reusable link time threshold")
                          }}</label> -->
                          <input
                            type="text"
                            name="time_threshold"
                            v-model="setup.settings[idx].shortio_threshold"
                          />
                        </div>
                        <div class="field">
                          <!-- <label for>{{ $t("reusable link time unit") }}</label> -->
                          <select
                            ref="time_threshold_unit"
                            class="ui selection dropdown"
                            name="time_threshold_unit"
                            v-model="setup.settings[idx].shortio_threshold_unit"
                          >
                            <option value="">{{ $t("select one") }}</option>
                            <option value="day">{{ $t("day") }}</option>
                            <option value="week">{{ $t("week") }}</option>
                            <option value="month">{{ $t("month") }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="inline fields">
                    <label>{{ $t("social networks") }}</label>
                    <div class="field">
                      <div class="ui toggle checkbox">
                        <input
                          type="checkbox"
                          name="facebook"
                          v-model="setup.settings[idx].social_facebook"
                        />
                        <label>{{ $t("facebook") }}</label>
                      </div>
                    </div>
                    <div class="field">
                      <div class="ui toggle checkbox">
                        <input
                          type="checkbox"
                          name="whatsapp"
                          v-model="setup.settings[idx].social_whatsapp"
                        />
                        <label>{{ $t("whatsapp") }}</label>
                      </div>
                    </div>
                    <div class="field">
                      <div class="ui toggle checkbox">
                        <input
                          type="checkbox"
                          name="twitter"
                          v-model="setup.settings[idx].social_twitter"
                        />
                        <label>{{ $t("twitter") }}</label>
                      </div>
                    </div>
                  </div> -->
                  <!-- <div class="ui dividing header">
                    {{ $t("visalink connection info") }}
                  </div>
                  <div class="fields">
                    <div class="ten wide field">
                      <label for="">{{ $t("key") }}</label>
                      <input
                        type="text"
                        name="key"
                        v-model="setup.settings[idx].key"
                      />
                    </div>
                    <div class="six wide field">
                      <label>{{ $t("environment") }}</label>
                      <select
                        class="ui selection dropdown"
                        v-model="setup.settings[idx].environment"
                        ref="environment_dropdown"
                      >
                        <option value="">{{ $t("select one") }}</option>
                        <option value="development">{{
                          $t("development")
                        }}</option>
                        <option value="production">{{
                          $t("production")
                        }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="two fields">
                    <div class="field">
                      <label for="">{{ $t("user") }}</label>
                      <input
                        type="text"
                        name="user"
                        v-model="setup.settings[idx].user"
                      />
                    </div>
                    <div class="field">
                      <label for="">{{ $t("password") }}</label>
                      <input
                        type="text"
                        name="password"
                        v-model="setup.settings[idx].password"
                      />
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </generic-container>
      </div>
      <div class="ui bottom attached tab segment" data-tab="bulk">
        <div class="ui form" ref="form">
          <h5 class="ui dividing header">
            <i class="database icon"></i> {{ $t("database configuration") }}
          </h5>
          <div class="fields">
            <div class="seven wide field">
              <label for>{{ $t("host") }}</label>
              <input type="text" name="host" v-model="setup.database.host" />
            </div>
            <div class="seven wide field">
              <label for>{{ $t("database name") }}</label>
              <input
                type="text"
                name="database"
                v-model="setup.database.database_name"
              />
            </div>
            <div class="two wide field">
              <label for>{{ $t("port") }}</label>
              <input type="text" name="port" v-model="setup.database.port" />
            </div>
          </div>
          <div class="fields">
            <div class="six wide field">
              <label for>{{ $t("username") }}</label>
              <input
                type="text"
                name="username"
                v-model="setup.database.username"
              />
            </div>
            <div class="five wide field">
              <label for>{{ $t("password") }}</label>
              <input
                type="password"
                name="password"
                v-model="setup.database.password"
              />
            </div>
            <div class="five wide field">
              <label for>{{ $t("password confirmation") }}</label>
              <input
                type="password"
                name="password"
                v-model="setup.database.password"
              />
            </div>
          </div>
          <h5 class="ui dividing header">
            <i class="visa icon"></i> {{ $t("visalink") }}
          </h5>
          <div class="five wide field">
            <label for>{{ $t("maximum request per hour limit") }}</label>
            <input type="text" v-model="setup.maximum_visalink_request_limit" />
          </div>
          <div class="ui error message"></div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { local_api, error_toast, api_host } from "@/utils";
import { v4 } from "uuid";
import FileUploader from "@/components/FileUploader.vue";
import { quotas } from "@/modules/visalink/quotas";

export default {
  name: "VisalinkConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    GenericContainer,
    FileUploader,
  },
  computed: {},
  data() {
    return {
      setup: {
        settings: [],
        database: {
          host: "",
          port: "",
          database_name: "",
          username: "",
          password: "",
        },
        maximum_visalink_request_limit: "",
      },
      api_host: api_host,
      networks: [],
      profiles: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        local_api(vm, "post", "/visalink_generator/configuration/do-save", {
          s: vm.setup,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    add_setting() {
      let vm = this;
      vm.setup.settings.push({
        name: vm.$t("unnamed"),
        uuid: v4(),
      });
    },
    remove_setting(index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to delete setting?"),
        function () {
          vm.setup.settings.splice(index, 1);
        },
      );
    },
    error_uploading(err) {
      console.error(err);
    },
    end_uploading(index, file) {
      let vm = this;
      vm.setup.settings[index].file = file;
    },
    update_profiles() {
      let vm = this;
      if (vm.profiles && vm.profiles.length) {
        let snvls = vm.profiles.map((q) => {
          return { name: q.name, value: q.uuid };
        });
        window
          .jQuery(vm.$refs.profile_dropdown)
          .dropdown("setup menu", { values: snvls })
          .dropdown({
            onChange(value, text, $element) {
              let closest = window
                .jQuery($element)
                .closest(".selection.dropdown");
              if (closest) {
                let idx = window.jQuery(closest).data("idx");
                if (idx >= 0) {
                  vm.setup.settings[idx].profile_uuid = value;
                }
              }
            },
          });

        vm.$refs.profile_dropdown.map((qd, idx) => {
          let qvl = vm.setup.settings[idx].profile_uuid;
          if (qvl) window.jQuery(qd).dropdown("set selected", qvl);
        });
      } else {
        setTimeout(() => {
          vm.update_profiles();
        }, 500);
      }
    },
    update_networks() {
      let vm = this;
      /** Social networks dropdown */
      if (vm.networks && vm.networks.length) {
        let snvls = vm.networks.map((q) => {
          return { name: q.nombre, value: q.codigo };
        });
        window
          .jQuery(vm.$refs.social_networks_dropdown)
          .dropdown("setup menu", { values: snvls })
          .dropdown({
            onChange(value, text, $element) {
              let closest = window
                .jQuery($element)
                .closest(".selection.dropdown");
              if (closest) {
                let idx = window.jQuery(closest).data("idx");
                if (idx >= 0) {
                  vm.setup.settings[idx].social_networks = value;
                }
              }
            },
          });

        vm.$refs.social_networks_dropdown.map((qd, idx) => {
          let qvl = vm.setup.settings[idx].social_networks;
          if (qvl) window.jQuery(qd).dropdown("set selected", qvl.split(","));
        });
      } else {
        setTimeout(() => {
          vm.update_networks();
        }, 500);
      }
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/visalink_generator/configuration/do-get")
      .then((conf) => {
        if (conf && conf.settings) vm.setup.settings = conf.settings;
        if (conf && conf.database) vm.setup.database = conf.database;
        if (conf && conf.maximum_visalink_request_limit)
          vm.setup.maximum_visalink_request_limit =
            conf.maximum_visalink_request_limit;
      })
      .catch((err) => {
        error_toast(err);
      });

    window.jQuery(vm.$refs.tabss).find(".item").tab();
  },
  watch: {
    "setup.settings"() {
      let vm = this;
      setTimeout(() => {
        window.jQuery(vm.$refs.tabs).find(".item").tab();

        window.jQuery(vm.$refs.environment_dropdown).dropdown();

        let vls = quotas.map((q) => {
          return { name: vm.$t(q.name), value: q.code };
        });
        window
          .jQuery(vm.$refs.quota_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value, text, $element) {
              let closest = window
                .jQuery($element)
                .closest(".selection.dropdown");
              if (closest) {
                let idx = window.jQuery(closest).data("idx");
                if (idx >= 0) {
                  vm.setup.settings[idx].quota = value;
                }
              }
            },
          });

        vm.$refs.quota_dropdown.map((qd, idx) => {
          let qvl = vm.setup.settings[idx].quota;
          if (qvl) window.jQuery(qd).dropdown("set selected", qvl);
        });

        window.jQuery(vm.$refs.time_threshold_unit).dropdown();

        vm.update_networks();
        vm.update_profiles();
      }, 500);
    },
  },
  created: function () {
    let vm = this;
    local_api(vm, "post", "/visalink/link/do-get-social-networks")
      .then((networks) => {
        vm.networks = networks;
      })
      .catch((err) => {
        error_toast(err);
      });

    local_api(vm, "post", "/visalink/configuration/do-get")
      .then((conf) => {
        if (conf && conf.settings) {
          vm.profiles = conf.settings;
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
};
</script>
